import { jsx as a } from "react/jsx-runtime";
function d({
  children: i,
  level: x,
  marginBottom: t,
  marginTop: s
}) {
  t === void 0 && (t = 4);
  let f = " mb-" + t, l = " ", e = "text-3xl";
  return x === 2 && (e = "text-2xl"), x === 3 && (e = "text-xl"), x === 4 && (e = "text-lg"), t === 0 && (f = ""), s && s > 0 && (l = `mt-${s}`), /* @__PURE__ */ a(
    "h1",
    {
      className: e + " " + l + " " + f + " font-bold text-gray-600 dark:text-gray-200",
      children: i
    }
  );
}
export {
  d as Title
};
